import React, { useState, useEffect, createContext } from "react";

const viewportContext = createContext({});
const mobileBreakpointSetting = 991;

const ViewportProvider = ({ children }) => {
  const [height, setHeight] = useState(window.innerHeight);
  const [isMobile, setMobile] = useState(true);

  const handleWindowResize = () => {
    // setWidth(window.innerWidth);
    setHeight(window.innerHeight);
    if (window.innerWidth <= mobileBreakpointSetting) {
      setMobile(true);
    } else {
      setMobile(false);
    }
  };

  useEffect(() => {
    //get initial settings on load
    setHeight(window.innerHeight);
    if (window.innerWidth <= mobileBreakpointSetting) {
      setMobile(true);
    } else {
      setMobile(false);
    }

    //set listener
    window.addEventListener("resize", handleWindowResize);
    return () => window.removeEventListener("resize", handleWindowResize);
  }, []);

  return (
    <viewportContext.Provider value={{ isMobile, height }}>
      {children}
    </viewportContext.Provider>
  );
};

export { viewportContext, ViewportProvider };
